(() => {
  const selectors = {
    slider: ".js-we-design-it-all-ds__swiper",
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-next',
    sectionName: 'we-design-it-all-ds',
    swiper: '.swiper',
    swiperSlide: '.swiper-slide',
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev'
  };

  const sliderSections = document.querySelectorAll(`[data-section-type=${selectors.sectionName}]`);

  const setSwiperHeight = (swiper) => {
    const swiperSlides = swiper.querySelectorAll(selectors.swiperSlide);
    const allHeights = [];

    swiperSlides.forEach(slide => {
      allHeights.push(slide.offsetHeight);
    });

    const maxSlideHeight = Math.max(...allHeights);

    swiper.style.height = `${ maxSlideHeight * 1.3 }px`;
  }

  const initSliders = () => {
    sliderSections.forEach((section) => {
      const swiperContainer = section.querySelector(selectors.slider);
      const nextButton = section.querySelector(selectors.nextButton);
      const prevButton = section.querySelector(selectors.prevButton);

      const swiper = new Swiper(swiperContainer, {
        slidesPerView: 2,
        centeredSlides: true,
        spaceBetween: 80,
        loop: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 80,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 80,
          }
        }
      });

      bindBeforeAfterTouchHandling(section, swiper);
      setSwiperHeight(swiperContainer);
    });
  }

  const bindBeforeAfterTouchHandling = (section, swiper) => {
    if (!section || !swiper) return;

    const stopSwiperDrag = (event) => {
      if (!event.target.closest(".icv__arrow-wrapper")) return;

      swiper.allowTouchMove = false;
      event.stopPropagation();
    };

    const resumeSwiperDrag = () => {
      swiper.allowTouchMove = true;
    };

    const stopPropagationOnMove = (event) => {
      if (!event.target.closest(".icv__arrow-wrapper")) return;

      event.stopPropagation();
    };

    section.addEventListener('touchstart', stopSwiperDrag, { passive: true });
    section.addEventListener('touchmove', stopPropagationOnMove, { passive: true });
    section.addEventListener('touchend', resumeSwiperDrag);
    section.addEventListener('touchcancel', resumeSwiperDrag);
    section.addEventListener('pointerup', resumeSwiperDrag);
    section.addEventListener('pointercancel', resumeSwiperDrag);
  };

  /* destroySliders function is not used in the code. */
  const destroySliders = () => {
    document.querySelectorAll(`[data-section-type=${sectionName}]`).forEach((container) => {
      const swiperItem = container.querySelector(selectors.swiper);
      swiperItem.swiper && swiperItem.swiper.destroy();
    });
  };

  initSliders();

  Fancybox.bind("[data-fancybox='we-design-it-all']", {});

  window.addEventListener('resize', () => {
    sliderSections.forEach((section) => {
      const swiperContainer = section.querySelector(selectors.slider);
      setSwiperHeight(swiperContainer);
    });
  });
})();
